import '../../css/style.scss';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { UICheckoutPageController } from '../../../shared/scripts/ui_checkout/UICheckoutPageController.ts';
void init();
async function init() {
    EntryShared.initializeAudio();
    await EntryShared.initializeEntry();
    new UICheckoutPageController();
    EntryShared.sendPageVisitAnalyticEvent();
}
